import { FC, Fragment, JSX } from 'react';
import { Card, CardContent, Grid, Button, Box, CardActions } from '@mui/material';
// components
import SelectController from 'controller/Select';
import InputController from 'controller/InputController';
// constants, styles, interfaces
import { DvConstraintsFormProps } from 'interfaces';
import { forInputLabelBg, flexMarginTopEndCenter } from 'styles/commonComponentStyle';
import {
  NAME_TEXT,
  SAVE_TEXT,
  CHILDREN_1_TO_3_YEARS_TEXT,
  INFANTS_TEXT,
  ADULTS_AND_CHILDREN_TEXT,
  PREGNANT_AND_LACTATING_WOMEN_TEXT,
  UNIT_TEXT,
  UNIT_SELECT_MAPPED,
  FOOD_COMPONENT_TEXT,
} from 'constants/index';

const DvConstraintsForm: FC<DvConstraintsFormProps> = ({ isEdit = false, loading = false }): JSX.Element => {
  return (
    <Card sx={forInputLabelBg}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <InputController fieldType="text" name="foodComponent" disabled title={FOOD_COMPONENT_TEXT} />
          </Grid>

          <Grid item xs={12} lg={12}>
            <InputController isRequired fieldType="text" name="name" disabled={loading} title={NAME_TEXT} />
          </Grid>

          <Grid item xs={12} lg={12}>
            <InputController
              isRequired
              fieldType="number"
              name="infants"
              disabled={loading}
              title={INFANTS_TEXT}
            />
          </Grid>

          <Grid item xs={12} lg={12}>
            <InputController
              isRequired
              fieldType="number"
              name="adultsAndChildren"
              disabled={loading}
              title={ADULTS_AND_CHILDREN_TEXT}
            />
          </Grid>

          <Grid item xs={12} lg={12}>
            <InputController
              isRequired
              fieldType="number"
              name="children1To3Years"
              disabled={loading}
              title={CHILDREN_1_TO_3_YEARS_TEXT}
            />
          </Grid>

          <Grid item xs={12} lg={12}>
            <InputController
              isRequired
              fieldType="number"
              name="pregnantAndLactatingWomen"
              disabled={loading}
              title={PREGNANT_AND_LACTATING_WOMEN_TEXT}
            />
          </Grid>

          <Grid item xs={12} lg={12}>
            <SelectController
              isRequired
              name="unit"
              disabled={loading}
              title={UNIT_TEXT}
              options={UNIT_SELECT_MAPPED}
            />
          </Grid>
        </Grid>
      </CardContent>

      {isEdit ? (
        <CardActions>
          <Box sx={flexMarginTopEndCenter}>
            <Button type="submit" variant="contained" size="small" disabled={loading}>
              {SAVE_TEXT}
            </Button>
          </Box>
        </CardActions>
      ) : (
        <Fragment />
      )}
    </Card>
  );
};

export default DvConstraintsForm;
